import { SchedulesTable } from "@/components/schedules-table";
import { MobilePageTitle } from "@/components/ui/mobile-page-title";
import { ScrollableContainer } from "@/components/ui/scrollbar";
import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

export const Route = createFileRoute("/(protected)/scheduling/schedules/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation();
  return (
    <ScrollableContainer>
      <MobilePageTitle className="mt-6">
        {t("pages:dashboard.sidebar.gym_schedules")}
      </MobilePageTitle>
      <div className="h-max space-y-6 pr-6 pl-6 md:px-6">
        <SchedulesTable />
      </div>
    </ScrollableContainer>
  );
}
